import ResponseError from '@/core/utils/response-error';

type BffErrorBody = {
  error?: {
    code?: string;
  };
};

const INVALID_CART_ERROR_CODES = new Set(['CART_NOT_FOUND']);

const INVALID_CART_STATUS_CODES = new Set([404, 410]);

export function isInvalidShoppingCartStatus(status: number): boolean {
  return INVALID_CART_STATUS_CODES.has(status);
}

export function isInvalidShoppingCartErrorCode(code: string | undefined): boolean {
  if (!code) return false;
  return INVALID_CART_ERROR_CODES.has(code);
}

/**
 * True when the BFF reports the shopping cart no longer exists or is unusable.
 * Status 404/410 always qualify; other statuses require a known cart error code in the body.
 */
export async function isInvalidShoppingCartError(
  error: unknown,
): Promise<boolean> {
  if (!ResponseError.isResponseError(error)) return false;

  if (isInvalidShoppingCartStatus(error.response.status)) {
    return true;
  }

  try {
    const body = (await error.response.clone().json()) as BffErrorBody;
    return isInvalidShoppingCartErrorCode(body.error?.code);
  } catch {
    return false;
  }
}
